export const goalTypeData = [
  {
    Type: "Performance Goals",
    Description: "Goals that focus on enhancing an employee's performance in their current role.",
    Status: "Active",
    key: "1",
  },
  {
    Type: "Development Goals",
    Description: "Goals aimed at personal and professional growth to prepare for future roles or responsibilities.",
    Status: "Active",
    key: "2",
  },
  {
    Type: "Project Goals",
    Description: "Specific goals related to the completion and success of a project",
    Status: "Active",
    key: "3",
  },
  {
    Type: "Financial Goals",
    Description: "Goals that aim to achieve financial targets or improvements for the organization.",
    Status: "Active",
    key: "4",
  },
  {
    Type: "Team Goals",
    Description: "Goals set for a team to achieve collectively, fostering collaboration and cooperation.",
    Status: "Active",
    key: "5",
  },
];
